import cx from 'classnames';
import { ButtonGroup, Dropdown } from 'react-bootstrap';
import DotsIcon from '../../components/icons/dots';
import styles from './DropdownMenu.module.scss';
import Switch from '../../components/admin/switch';
import Button from '../../components/Button';
import Loader from "../../components/Loader/Loader";
import { Mixpanel } from '../../common/Mixpanel';

export const DropdownMenu = ({
  button = <DotsIcon />,
  buttonProps = {},
  className = 'ms-auto',
  itemClassName = '',
  style = {},
  menu,
  item = null,
  items = null,
  dropdownMenuProps = {},
  hideOption = null
}) => {
  if (!menu || !menu?.length) return null;

  const triggerEvent = (item) => {
    if (item?.mxEvent) {
      Mixpanel.track(true, item?.mxEvent, {
        cta_type: item?.title,
        ...(item?.eventProps || {}),
      });
    }
  };

  // `loading` drives the spinner below; it is not a DOM attribute, so it is kept
  // out of what gets spread onto the <button> react-bootstrap renders.
  const { loading: buttonLoading, ...toggleProps } = buttonProps;

  return (
    <Dropdown align="end" as={ButtonGroup} className={`custom-dropdown ${className}`} style={style}>
      <Dropdown.Toggle className={styles.dotBtn} {...toggleProps}>
        {buttonLoading ? (
          <div className="px-3">
            <Loader loading={true} position="absolute" color="inherit" size={22} thickness={2} />
          </div>
        ) : (
          button
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu className={`${styles.menuContainer} p-0 ${hideOption ? 'd-none' : ''}`} {...dropdownMenuProps}>
        {menu.map((a, i) => {
          const Icon = a?.icon;
          const isToggle = a?.type === 'toggle';
          const isButton = a?.type === 'button';
          const isInfo = a?.type === 'info';

          if (a?.hide) return null;

          if (isButton) {
            return (
              <Button
                key={a?.id || i}
                className={cx(
                  'w-75 d-flex p-3 m-2 mx-auto',
                  a?.initialValue ? styles.cursorDefault : ''
                )}
                loading={a?.loading}
                color={'primary'}
                onClick={(e) => {
                  triggerEvent(a);
                  a?.onClick?.(e);
                }}>
                {a?.title || a?.label}
              </Button>
            );
          }

          return (
            <Dropdown.Item
              className={cx(styles.menu, isInfo ? styles.info : '', itemClassName, a?.separate ? styles.line : '')}
              key={a?.id || i}
              onClick={(e) => {
                triggerEvent(a);
                if (items) {
                  a?.onClick(items?.id, items?.data, items?.originalData);
                } else {
                  a?.onClick?.(
                    'initialValue' in a ? { e: e, value: !a?.initialValue, item } : item
                  );
                }
              }}
              disabled={a?.disabled}>
              {Icon && <Icon style={{ width: 24, height: 24 }} />}
              {isToggle && <Switch checked={a?.initialValue} />}
              {a?.title || a?.label}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};
